import React, { useEffect, useRef, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TabPanel from "@mui/lab/TabPanel";
import { TabContext } from "@mui/lab";
import { TextField } from "@mui/material";
import CameraAltIcon from "@mui/icons-material/CameraAlt";

import "./Section.css";
import SuccessAlert from "../components/success-alert/SuccessAlert";
import ErrorAlert from "../components/error-alert/ErrorAlert";
import useLanguages from "../hooks/useLanguages";
import { API, SERVER_DOMAIN } from "../assets/staticData";
import { toast } from "react-toastify";

export default function Promotions({ user }) {
  const langs = useLanguages();

  const [value, setValue] = useState("0");
  const [data, setData] = useState([]);
  const [images, setImages] = useState([]);
  const [success, setSuccess] = useState(false);
  const [fail, setFail] = useState(false);
  const [loading, setLoading] = useState(true);
  const hiddenFileInput = useRef([]);

  let userToken = localStorage.getItem("userToken");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  let tabStyle = { textTransform: "capitalize", fontWeight: "500" };

  // Get Data from backend
  useEffect(() => {
    let docs = langs.map((item) => ({
      header1: "",
      desc1: "",
      header2: "",
      header3: "",
      btnT: "",
      btnL: "",
      cards: [...Array(4)].map((_, i) => ({
        title: "",
        text: "",
      })),
      language: item.attributes.language,
    }));
    setData(docs);

    let imgDocs = langs.map((item) => ({
      imgs: [],
      language: item.attributes.language,
    }));
    setImages(imgDocs);

    async function getData() {
      await fetch(`${API}/promo-page`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
      }).then(async (res) => {
        const response = await res.json();
        const apiData = response.data?.attributes?.data || [];

        setData((prevData) => {
          return prevData.map((localItem) => {
            const apiItem = apiData.find((apiItem) => apiItem.language === localItem.language);

            if (apiItem) {
              return {
                ...localItem,
                header1: apiItem.header1 || localItem.header1,
                header2: apiItem.header2 || localItem.header2,
                header3: apiItem.header3 || localItem.header3,
                btnT: apiItem.btnT || localItem.btnT,
                btnL: apiItem.btnL || localItem.btnL,
                desc1: apiItem.desc1 || localItem.desc1,
                cards: apiItem.cards || localItem.cards,
              };
            } else {
              return localItem;
            }
          });
        });

        const apiImages = response.data?.attributes?.images || [];

        setImages((prevData) => {
          return prevData.map((localItem) => {
            const apiItem = apiImages.find((apiItem) => apiItem.language === localItem.language);

            if (apiItem) {
              return {
                ...localItem,
                imgs: apiItem.imgs || localItem.imgs,
              };
            } else {
              return localItem;
            }
          });
        });

        setLoading(false);
      });
    }

    getData();
  }, [langs]);

  const submitData = () => {
    fetch(`${API}/promo-page`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify({
        data: { data: data },
      }),
    }).then(async (res) => {
      if (res.ok) {
        setSuccess(true);
      } else {
        setFail(true);
      }
    });
  };

  const handleImageChange = (e, index, imgIndex) => {
    const formData = new FormData();
    const file = e.target.files[0];

    if (file) {
      formData.append("files", file);

      fetch(`${API}/upload`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
        body: formData,
      }).then(async (res) => {
        const response = await res.json();
        const imageURL = response[0]?.url;

        let updatedImages = [...images];

        // Initialize images array if not already initialized
        if (!updatedImages[index].imgs) {
          updatedImages[index].imgs = [];
        }

        // Update the specific image URL in the array
        updatedImages[index].imgs[imgIndex] = imageURL;

        fetch(`${API}/promo-page`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userToken}`,
          },
          body: JSON.stringify({
            data: { images: updatedImages },
          }),
        }).then((res) => {
          if (res.ok) {
            setImages(updatedImages);
            toast("Updated Successfully", {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              type: "success",
            });
          }
        });
      });
    }
  };

  return (
    <TabContext value={value}>
      <Box sx={{ width: "100%" }}>
        <h3 style={{ textTransform: "capitalize" }}>Promotions Page Settings</h3>
        <Tabs
          value={value}
          onChange={handleChange}
          textColor="secondary"
          indicatorColor="secondary"
          aria-label="secondary tabs">
          {langs?.map((item, index) => {
            return (
              <Tab
                key={index}
                sx={tabStyle}
                value={index.toString()}
                label={item.attributes.language}
                icon={
                  <img
                    src={SERVER_DOMAIN + item.attributes.icon.data.attributes.url}
                    style={{ width: 25, aspectRatio: 1, borderRadius: 20 }}
                  />
                }
                iconPosition="start"
              />
            );
          })}
        </Tabs>

        {loading ? (
          <></>
        ) : (
          <>
            {langs?.map((item, index) => {
              return (
                <TabPanel value={index.toString()} key={index}>
                  <SuccessAlert show={success} setShow={(v) => setSuccess(v)} />
                  <ErrorAlert show={fail} setShow={(v) => setFail(v)} />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 20,
                    }}>
                    <h3>Action Button</h3>
                    <TextField
                      label="Button Text"
                      sx={{ width: 350, mt: 1 }}
                      value={data[index]?.btnT || ""}
                      onChange={(e) => {
                        const newData = [...data];
                        newData[index].btnT = e.target.value;
                        setData(newData);
                      }}
                    />
                    <TextField
                      label="Button Link"
                      sx={{ width: 350, mb: 1 }}
                      value={data[index]?.btnL || ""}
                      onChange={(e) => {
                        const newData = [...data];
                        newData[index].btnL = e.target.value;
                        setData(newData);
                      }}
                    />

                    <div>
                      <h3>Header 1</h3>
                      <TextField
                        label="Text"
                        sx={{ width: 450, mt: 1 }}
                        value={data[index]?.header1 || ""}
                        onChange={(e) => {
                          const newData = [...data];
                          newData[index].header1 = e.target.value;
                          setData(newData);
                        }}
                      />
                    </div>
                    <div>
                      <h3>Description 1</h3>
                      <TextField
                        label="Text"
                        sx={{ width: 450, mt: 1 }}
                        value={data[index]?.desc1 || ""}
                        multiline
                        rows={5}
                        onChange={(e) => {
                          const newData = [...data];
                          newData[index].desc1 = e.target.value;
                          setData(newData);
                        }}
                      />
                    </div>
                    <div className="divider"></div>

                    <div className="grid grid-cols-1 lg:grid-cols-2">
                      {[...Array(4)].map((item, idx) => (
                        <div
                          key={idx}
                          className="w-full flex-col gap-5 mb-6"
                          style={{ alignItems: "flex-start" }}>
                          <h3>Card {idx + 1}</h3>
                          <TextField
                            label="Title"
                            sx={{ width: 350 }}
                            value={data[index]?.cards[idx]?.title || ""}
                            onChange={(e) => {
                              const newData = [...data];
                              newData[index].cards[idx].title = e.target.value;
                              setData(newData);
                            }}
                          />
                          <TextField
                            label="Text"
                            sx={{ width: 350 }}
                            value={data[index]?.cards[idx]?.text || ""}
                            onChange={(e) => {
                              const newData = [...data];
                              newData[index].cards[idx].text = e.target.value;
                              setData(newData);
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="divider"></div>

                  <div>
                    <h3>Header 2</h3>
                    <TextField
                      label="Text"
                      sx={{ width: 450, mt: 1 }}
                      value={data[index]?.header2 || ""}
                      onChange={(e) => {
                        const newData = [...data];
                        newData[index].header2 = e.target.value;
                        setData(newData);
                      }}
                    />
                  </div>

                  <div className="mt-3">
                    <h3>Header 3</h3>
                    <TextField
                      label="Text"
                      sx={{ width: 450, mt: 1 }}
                      value={data[index]?.header3 || ""}
                      onChange={(e) => {
                        const newData = [...data];
                        newData[index].header3 = e.target.value;
                        setData(newData);
                      }}
                    />
                  </div>

                  {user.perms[27].edit && (
                    <>
                      <div className="submitBTN" onClick={() => submitData(item, index)}>
                        Save Changes
                      </div>

                      <div className="divider"></div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          gap: 25,
                          flexWrap: "wrap",
                        }}>
                        {[...Array(5)].map((_, imgIndex) => (
                          <div className="w-2/12" key={imgIndex}>
                            <h3 className="ml-3">
                              {imgIndex === 0
                                ? "Header"
                                : imgIndex === 4
                                ? "Mobile Header"
                                : "Image" + (imgIndex + 1)}
                            </h3>

                            <div
                              className="group relative w-full mt-4 rounded-[15px] overflow-hidden cursor-pointer border-2 border-sky-400"
                              onClick={() => hiddenFileInput.current[imgIndex].click()}>
                              <img
                                style={{
                                  width: "100%",
                                  aspectRatio: 1,
                                  objectFit: "cover",
                                  transition: "0.2s",
                                }}
                                src={
                                  images[index]?.imgs?.[imgIndex]
                                    ? SERVER_DOMAIN + images[index]?.imgs[imgIndex]
                                    : require("../assets/placeholder-image.png")
                                }
                              />

                              <div className="group absolute top-0 left-0 w-full rounded-[15px] h-full bg-black bg-opacity-0 hover:bg-opacity-30 transition-opacity flex items-center justify-center">
                                <CameraAltIcon
                                  style={{ fontSize: 45 }}
                                  className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                                />
                              </div>

                              <input
                                type="file"
                                accept="image/png, image/jpeg"
                                onChange={(e) => handleImageChange(e, index, imgIndex)}
                                ref={(el) => (hiddenFileInput.current[imgIndex] = el)}
                                style={{ display: "none" }}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                </TabPanel>
              );
            })}
          </>
        )}
      </Box>
    </TabContext>
  );
}
